<script setup lang="ts">
interface Props {
	description: string;
	heading: string;
}

defineProps<Props>();
</script>
<template>
	<div class="relative mt-3xl mx-3xl lg:mx-0 overflow-y-auto h-[max-content]">
		<div class="flex w-full gap-md items-start justify-center flex-col mb-md">
			<span class="h-7xl font-semibold text-gray-900">{{ heading }}</span>
			<span
				class="text-justify text-gray-700 text-sm font-normal"
				v-html="description"
			>
			</span>
		</div>
	</div>
</template>
